import type {EditionApiModel} from '../../../api/program';

export function isEditionSigned(edition: EditionApiModel) {
  return (
    edition?.coach_ids.every(coachId => edition.coaches[coachId].signed) ??
    false
  );
}
